import Snake from "./game/libs/snake";
import Player from "./game/libs/player";

var baseurl = "https://snake.lexserest.pw/set/";
var url = window.location.href;
var token = "";

if (url.split("?").length > 1) {
  token = window.location.href.split("?")[1].split("=")[1];
}

function send(url) {
  var get_script = document.createElement("script");
  get_script.setAttribute("src", url);
  document.head.appendChild(get_script);
  get_script.onload = function() {
    get_script.remove();
  };
}

if (token) {
  //$('footer').style.display = 'none';

  try {
    // history.replaceState({}, 'main', window.location.pathname);
  } catch (e) {}

  Snake.onEnd = function() {
    var score = Player.score;
    var t = score.toString(16) + "j" + token;
    if (score) send(baseurl + t);
  };
}
